import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform, SafeAreaView } from 'react-native';
import Monthly from './MonthlyDetails';
import typo from '../../Theme/Typo';
import MonthSelector from './MonthSelector';
import Details from './Details';
import { subMinutes, subDays, subMonths, startOfMonth } from 'date-fns';
import { ScrollView } from 'react-native-gesture-handler';

export function startOfPreviousMonthDstSafe(date) {
    const startDate = startOfMonth(subDays(subMonths(date, 1), 7));
    return subMinutes(
        startDate,
        startDate.getTimezoneOffset()
    );
}

const Accounting = () => {
    const [activeTab, setActiveTab] = useState('monthlyReport');
    const [selectedDate, setSelectedDate] = useState(startOfPreviousMonthDstSafe(new Date()));

    const TabSwitch = () => {
        switch (activeTab) {
            case 'monthlyReport':
                return <Monthly date={selectedDate} />;
            case 'details':
                return <Details date={selectedDate} />;
            default:
                return null;
        }
    };

    return (
        <SafeAreaView style={typo.mainBackground}>
            <ScrollView style={{ flex: 1, backgroundColor: "#FFF" }}>
                <View style={styles.container}>
                    <View style={styles.periodView}>
                        <Text style={styles.label}>Période :</Text>
                        <MonthSelector
                            additionalStyle={styles.monthPicker}
                            minDate={new Date("2024-07-01")}
                            maxDate={startOfPreviousMonthDstSafe(new Date())}
                            value={selectedDate}
                            onChange={setSelectedDate} />
                    </View>
                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            style={[styles.tabButton, activeTab === 'monthlyReport' && styles.activeTabButton]}
                            onPress={() => setActiveTab('monthlyReport')}
                        >
                            <Text style={activeTab === 'monthlyReport' ? styles.activeTabText : styles.tabText}>Compte rendu mensuel</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                            style={[styles.tabButton, activeTab === 'details' && styles.activeTabButton]}
                            onPress={() => setActiveTab('details')}
                        >
                            <Text style={activeTab === 'details' ? styles.activeTabText : styles.tabText}>En détail</Text>
                        </TouchableOpacity>
                    </View>
                    <TabSwitch />
                </View>
            </ScrollView>
        </SafeAreaView>
    );
};

const styles = StyleSheet.create({
    container: {
        padding: 20,
        backgroundColor: '#FFFFFF',
        flex: 1,
        gap: 20,
        zIndex: -1
    },
    periodView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        zIndex: 1
    },
    monthPicker: {
        width: 200,
    },
    label: {
        textAlign: "center",
        fontSize: 18,
        fontWeight: 'bold',
    },
    buttonContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    tabButton: {
        flex: 1,
        padding: 10,
        alignItems: 'center',
        justifyContent: 'center',
        borderBottomWidth: 2,
        borderBottomColor: 'transparent',
    },
    activeTabButton: {
        borderBottomColor: '#C4027A',
    },
    tabText: {
        textAlign: 'center',
        fontSize: 16,
        color: 'gray',
        fontWeight: "600"
    },
    activeTabText: {
        textAlign: 'center',
        fontSize: 16,
        color: '#C4027A',
        fontWeight: 'bold',
    },
    pickerContainer: {
        borderWidth: 1,
        borderColor: '#C4027A',
        borderRadius: 8,
        marginVertical: 10,
    },
});

export default Accounting;
